//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'

import { TICKET_TYPES_COLOR_MAP } from 'constants/colorMaps'

import Badge from 'components/Shared/Badge/Index'
import Icon from 'components/Shared/Icon/Index'

const StyledBadge = styled(Badge)`
  padding: 0 5px;
`

const getIconName = (ticketType) => {
  return ({
    'Epic': 'icon-epic-12',
    'User Story': 'icon-story-12',
    'Task': 'icon-audit-12',
    'Sub-Task': 'icon-subtask-12',
    'Bug': 'icon-bug-12',
    'Invalid Type': 'icon-close-12',
  }[ticketType])
}

const TicketTypeBadge = ({ ticketType, tooltipId, noMargin }) => {
  const iconName = getIconName(ticketType)
  const badgeColor = TICKET_TYPES_COLOR_MAP[ticketType]

  if (!iconName) {
    return null
  }

  return (
    <StyledBadge
      margin={noMargin ? '0' : '4px'}
      color={badgeColor}
      data-tooltip-content={ticketType}
      data-tooltip-id={tooltipId}
    >
      <Icon iconName={iconName} />
    </StyledBadge>
  )
}

TicketTypeBadge.propTypes = {
  ticketType: PropTypes.string,
  tooltipId: PropTypes.string,
  noMargin: PropTypes.bool,
}

export default TicketTypeBadge
